import type { PersonDetail } from "@/api/db/people";
import { ConflictRow } from "@/components/people/conflict-row";
import { Button } from "@/components/ui/button";
import { useResolveDivergence } from "@/hooks/use-resolve-divergence";
import { RevisaoLabels } from "@/lib/labels/revisao";

type Divergence = PersonDetail["divergences"][number];

export function DivergenceResolution({
	divergence,
	slots,
	onResolved,
}: {
	divergence: Divergence;
	slots?: boolean;
	onResolved?: () => void;
}) {
	const { resolve, isPending } = useResolveDivergence();

	function handleResolve(choice: "keep" | "replace") {
		resolve({ id: divergence.id, choice }, { onSuccess: onResolved });
	}

	return (
		<>
			<ConflictRow
				slots={slots}
				field={divergence.field}
				valueA={RevisaoLabels.divergenceValue(
					divergence.field,
					"current",
					divergence.current_value,
				)}
				sourceA={null}
				valueB={RevisaoLabels.divergenceValue(
					divergence.field,
					"incoming",
					divergence.incoming_value,
				)}
				sourceB={null}
				detail={null}
			/>

			<div className="flex flex-wrap gap-2">
				<Button
					data-slot="keep"
					variant="outline"
					size="sm"
					disabled={isPending}
					onClick={() => handleResolve("keep")}
				>
					{RevisaoLabels.keep}
				</Button>

				<Button
					data-slot="replace"
					variant="secondary"
					size="sm"
					disabled={isPending}
					onClick={() => handleResolve("replace")}
				>
					{RevisaoLabels.replace}
				</Button>
			</div>
		</>
	);
}
